import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getRoutes, createRoute, CreateRouteData } from '../api/routes';

export const useRoutes = (queryString: string = '') =>
  useQuery({
    queryKey: ['routes', queryString],
    queryFn: () => getRoutes(queryString),
    enabled: !!queryString,
  });

export const useVelodromeIndoorsRoutes = () =>
  useQuery({
    queryKey: ['routes', 'loop_velodrome_indoors'],
    queryFn: () => getRoutes('scope=loop_velodrome_indoors'),
  });

export const useVelodromeOutdoorsRoutes = () =>
  useQuery({
    queryKey: ['routes', 'loop_velodrome_outdoors'],
    queryFn: () => getRoutes('scope=loop_velodrome_outdoors'),
  });

export const useCreateRoute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateRouteData) => createRoute(data),
    onSuccess: (_data, variables) => {
      // Invalidate the routes query based on the route category
      if (variables.route_category === 2200) {
        queryClient.invalidateQueries({ queryKey: ['routes', 'scope=loop_velodrome_indoors'] });
      } else if (variables.route_category === 2100) {
        queryClient.invalidateQueries({ queryKey: ['routes', 'scope=loop_velodrome_outdoors'] });
      }
      // Also invalidate generic routes queries
      queryClient.invalidateQueries({ queryKey: ['routes'] });
    },
  });
};
